import { useRef, useState } from 'react'
import {
  Button, ButtonGroup, Popper, Grow, Paper, ClickAwayListener,
  MenuList, MenuItem, ListItemIcon, ListItemText,
} from '@mui/material'
import { ArrowDropDown, Add, ContentCopy } from '@mui/icons-material'

export default function SplitButton({ onCreateNew, onCopyFromPlan }) {
  const [open, setOpen] = useState(false)
  const anchorRef = useRef(null)

  return (
    <>
      <ButtonGroup variant="contained" ref={anchorRef}>
        <Button onClick={onCreateNew} startIcon={<Add />}>
          Create a Plan
        </Button>
        <Button
          size="small"
          onClick={() => setOpen((prev) => !prev)}
          sx={{ px: 0.5 }}
        >
          <ArrowDropDown />
        </Button>
      </ButtonGroup>

      <Popper open={open} anchorEl={anchorRef.current} transition disablePortal sx={{ zIndex: 1300 }}>
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper elevation={8}>
              <ClickAwayListener onClickAway={() => setOpen(false)}>
                <MenuList dense>
                  <MenuItem onClick={() => { setOpen(false); onCreateNew() }}>
                    <ListItemIcon><Add fontSize="small" /></ListItemIcon>
                    <ListItemText>Create New</ListItemText>
                  </MenuItem>
                  <MenuItem onClick={() => { setOpen(false); onCopyFromPlan() }}>
                    <ListItemIcon><ContentCopy fontSize="small" /></ListItemIcon>
                    <ListItemText>Create Modification / Copy from Plan</ListItemText>
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  )
}
